var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedLocation.nasid && _vm.selectedLocation.nasid > 0
    ? _c(
        "v-card",
        {
          ref: "PlanAndPayment",
          class: _vm.page,
          staticStyle: { background: "#f8f8f8" }
        },
        [
          _c(
            "v-snackbar",
            {
              staticClass: "custom-snackbar",
              attrs: {
                color: _vm.popup.type,
                timeout: 3000,
                top: "top",
                bottom: false
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "action",
                    fn: function(ref) {
                      var attrs = ref.attrs
                      return [
                        _c(
                          "v-btn",
                          _vm._b(
                            {
                              attrs: { dark: "", text: "" },
                              on: {
                                click: function($event) {
                                  _vm.popup.visible = false
                                }
                              }
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          [_vm._v("Close")]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                673094236
              ),
              model: {
                value: _vm.popup.visible,
                callback: function($$v) {
                  _vm.$set(_vm.popup, "visible", $$v)
                },
                expression: "popup.visible"
              }
            },
            [_vm._v(" " + _vm._s(_vm.popup.text) + " ")]
          ),
          _vm.page != "gaurenteeCampaign"
            ? _c(
                "div",
                [
                  _c(
                    "v-toolbar",
                    {
                      staticStyle: {
                        "border-radius": "0px",
                        background: "#fff"
                      },
                      attrs: { fixed: "", flat: "" }
                    },
                    [
                      _vm.fromSettings
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.close()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "1.25rem",
                            "font-weight": "700"
                          },
                          attrs: { dense: "" }
                        },
                        [
                          _c("span", {
                            domProps: { textContent: _vm._s(_vm.header) }
                          })
                        ]
                      ),
                      _c("v-spacer"),
                      !_vm.fromSettings
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "text-capitalize",
                              style: { color: "rgb(199 199 199)" },
                              attrs: { text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.skipPlanSetting()
                                }
                              }
                            },
                            [_vm._v(" skip ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.page == "plans" || _vm.page == "send-coupon"
                    ? _c(
                        "v-card-text",
                        {
                          staticStyle: {
                            width: "100%",
                            height: "auto",
                            "max-height": "auto",
                            padding: "0"
                          }
                        },
                        [
                          _c("div", { staticStyle: { background: "#fff" } }, [
                            _c(
                              "div",
                              { staticStyle: { padding: "0 1rem 1rem 1rem" } },
                              [
                                _vm.page == "plans"
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "mb-0",
                                        staticStyle: {
                                          "font-size": "0.75rem",
                                          "font-weight": "700"
                                        }
                                      },
                                      [_vm._v(" Data Usage Plans ")]
                                    )
                                  : _vm._e(),
                                _vm.page == "send-coupon"
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "mb-0",
                                        staticStyle: {
                                          "font-size": "0.75rem",
                                          "font-weight": "700"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " Choose data plan and send to customer "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.page == "plans"
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "mb-0",
                                        staticStyle: { "font-size": "0.75rem" }
                                      },
                                      [
                                        _vm._v(
                                          " Customers will choose from the following data usage plans and accordingly pay for it "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]),
                          _c(
                            "div",
                            [
                              _c(
                                "v-simple-table",
                                {
                                  staticStyle: {
                                    background: "#f8f8f8",
                                    padding: "0 1rem",
                                    "font-size": "14px"
                                  }
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _vm.page == "send-coupon"
                                        ? _c(
                                            "th",
                                            { staticClass: "text-center" },
                                            [_vm._v("Select")]
                                          )
                                        : _vm._e(),
                                      _c("th", [
                                        _vm._v("Data Limit"),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#f06b69" } },
                                          [_vm._v("*")]
                                        )
                                      ]),
                                      _c("th", [
                                        _vm._v("Validity"),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#f06b69" } },
                                          [_vm._v("*")]
                                        )
                                      ]),
                                      _c("th", [
                                        _vm._v("Price"),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#f06b69" } },
                                          [_vm._v("*")]
                                        )
                                      ]),
                                      _vm.page == "plans"
                                        ? _c(
                                            "th",
                                            { staticClass: "text-center" },
                                            [_vm._v("Select")]
                                          )
                                        : _vm._e()
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.plans, function(setting, ind) {
                                      return _c(
                                        "tr",
                                        {
                                          key: "sett" + ind,
                                          staticStyle: {
                                            height: "3rem",
                                            "font-weight": "500"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openConfirmPopup(
                                                setting
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm.page == "send-coupon"
                                            ? _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm.page == "send-coupon"
                                                    ? _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.selectedCoupon,
                                                            expression:
                                                              "selectedCoupon"
                                                          }
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "coupon",
                                                          color: "#f06b69"
                                                        },
                                                        domProps: {
                                                          value: setting,
                                                          checked: _vm._q(
                                                            _vm.selectedCoupon,
                                                            setting
                                                          )
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            _vm.selectedCoupon = setting
                                                          }
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.dataFormat(
                                                  setting.data_limit *
                                                    1024 *
                                                    1024
                                                )
                                              )
                                            )
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.timeFormat(
                                                  setting.time_limit
                                                )
                                              )
                                            )
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  setting.price == 0
                                                    ? "Free Plan"
                                                    : "₹" + setting.price
                                                ) +
                                                " "
                                            )
                                          ]),
                                          _vm.page == "plans"
                                            ? _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _c("v-checkbox", {
                                                    staticStyle: {
                                                      margin: "auto",
                                                      width: "1.75rem",
                                                      height: "2rem"
                                                    },
                                                    attrs: {
                                                      color: "#f06b69",
                                                      value: !setting.active
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return function() {
                                                          return false
                                                        }.apply(null, arguments)
                                                      }
                                                    },
                                                    model: {
                                                      value: setting.active,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          setting,
                                                          "active",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "setting.active"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "right",
                                    "padding-right": "1rem",
                                    "font-size": ".75rem"
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("mdi-info")]),
                                  _vm._v("Tap on existing plan to delete ")
                                ],
                                1
                              ),
                              _vm.dataPlanPopupType
                                ? _c("DataPlanPopup", {
                                    ref: "dataPlanPopup",
                                    attrs: {
                                      type: _vm.dataPlanPopupType,
                                      coupon: _vm.selectedCoupon,
                                      selectedLocation: _vm.selectedLocation
                                    },
                                    on: {
                                      "emitted-plan": function(newPlan) {
                                        this$1.plans.push(newPlan)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "2rem"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    background: "#f06b69 !important",
                                    "border-color": "#f06b69 !important",
                                    height: "3em"
                                  },
                                  attrs: { block: "", color: "error" },
                                  on: {
                                    click: function($event) {
                                      return _vm.savePlans()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.saveText || "Save") + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.page == "payment"
                    ? _c(
                        "v-card-text",
                        {
                          staticStyle: {
                            width: "100%",
                            height: "auto",
                            "max-height": "auto",
                            padding: "0"
                          }
                        },
                        [
                          _c(
                            "v-simple-table",
                            {
                              staticStyle: {
                                background: "#f8f8f8",
                                padding: "0 1rem",
                                "font-size": "14px"
                              }
                            },
                            [
                              _c("tbody", [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        "font-size": "0.875rem",
                                        "font-weight": "700"
                                      }
                                    },
                                    [_vm._v("Cash")]
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _c("v-checkbox", {
                                        staticStyle: {
                                          margin: "auto",
                                          width: "1.75rem",
                                          height: "2rem"
                                        },
                                        attrs: { color: "#f06b69" },
                                        model: {
                                          value: _vm.isCash,
                                          callback: function($$v) {
                                            _vm.isCash = $$v
                                          },
                                          expression: "isCash"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        "font-size": "0.875rem",
                                        "font-weight": "700"
                                      }
                                    },
                                    [_vm._v("UPI")]
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _c("v-checkbox", {
                                        staticStyle: {
                                          margin: "auto",
                                          width: "1.75rem",
                                          height: "2rem"
                                        },
                                        attrs: { color: "#f06b69" },
                                        model: {
                                          value: _vm.isUpi,
                                          callback: function($$v) {
                                            _vm.isUpi = $$v
                                          },
                                          expression: "isUpi"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        "font-size": "0.875rem",
                                        "font-weight": "700"
                                      }
                                    },
                                    [_vm._v("Online")]
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _c("v-checkbox", {
                                        staticStyle: {
                                          margin: "auto",
                                          width: "1.75rem",
                                          height: "2rem"
                                        },
                                        attrs: { color: "#f06b69" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showAcctDetailsPopup()
                                          }
                                        },
                                        model: {
                                          value: _vm.isOnline,
                                          callback: function($$v) {
                                            _vm.isOnline = $$v
                                          },
                                          expression: "isOnline"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ]
                          ),
                          _vm.isUpi
                            ? _c("v-text-field", {
                                staticClass: "mx-3",
                                attrs: {
                                  rules: [_vm.rules.upi],
                                  label: "Enter UPI id",
                                  placeholder: "e.g. sharma@icici",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.paymentObject.upiId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.paymentObject, "upiId", $$v)
                                  },
                                  expression: "paymentObject.upiId"
                                }
                              })
                            : _vm._e(),
                          _vm.isOnline
                            ? _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "alert-sty" },
                                        [
                                          _c("div", [
                                            _vm._v("Account Holder's Name: "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.accountDetails
                                                    .accountHoldersName
                                                )
                                              )
                                            ])
                                          ]),
                                          _c("div", [
                                            _vm._v("Account Number: "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.accountDetails
                                                    .accountNumber
                                                )
                                              )
                                            ])
                                          ]),
                                          _c("div", [
                                            _vm._v("IFSC Code: "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.accountDetails.ifsc)
                                              )
                                            ])
                                          ]),
                                          _c("div", [
                                            _vm._v("PAN Number: "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.accountDetails.panNumber
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm.accountDetails.gstNumber
                                            ? _c("div", [
                                                _vm._v("GST Number: "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.accountDetails
                                                        .gstNumber
                                                    )
                                                  )
                                                ])
                                              ])
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#999999",
                                                "font-size": ".8em",
                                                "margin-top": "1em"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "font-size": "1.2em",
                                                    "vertical-align":
                                                      "text-bottom"
                                                  }
                                                },
                                                [_vm._v("mdi-information")]
                                              ),
                                              _vm._v(
                                                " You can update these details by emailing us at "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "mailto:contact@i2e1.com"
                                                  }
                                                },
                                                [_vm._v("contact@i2e1.com")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-card-text",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "2rem"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    background: "#f06b69 !important",
                                    "border-color": "#f06b69 !important",
                                    height: "3em"
                                  },
                                  attrs: {
                                    block: "",
                                    color: "error",
                                    disabled:
                                      (!_vm.isCash &&
                                        !_vm.isUpi &&
                                        !_vm.isOnline) ||
                                      (_vm.isUpi && !_vm.paymentObject.upiId) ||
                                      (_vm.isOnline &&
                                        !_vm.accountDetails.accountNumber)
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.savePaymentMethod()
                                    }
                                  }
                                },
                                [_vm._v(" Save ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.page == "gaurenteeCampaign" &&
          _vm.gaurenteeCampaign.page == "setter"
            ? _c("div", { staticClass: "ge-card" }, [
                _c("div", { staticStyle: { "font-weight": "600" } }, [
                  _vm._v("You are part of")
                ]),
                _c("div", { staticStyle: { "font-weight": "600" } }, [
                  _vm._v("Guranteed Income Scheme")
                ]),
                _c(
                  "div",
                  { staticStyle: { "font-weight": "600", color: "#f4693a" } },
                  [_vm._v(" You will get â‚¹500 for next 3 months ")]
                ),
                _c("hr", {
                  staticStyle: { "border-style": "dashed", margin: "1rem 0" }
                }),
                _c("div", { staticStyle: { "font-weight": "600" } }, [
                  _vm._v("Enter UPI Details")
                ]),
                _c("div", [
                  _vm._v("in which you want to receive monthly bonus")
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.gaurenteeCampaign.upi,
                      expression: "gaurenteeCampaign.upi"
                    }
                  ],
                  staticStyle: {
                    width: "100%",
                    height: "2.5rem",
                    border: "1px solid grey",
                    "border-radius": "4px",
                    padding: "1rem",
                    margin: "1rem auto"
                  },
                  attrs: { placeholder: "e.g. rakesh@oksbi" },
                  domProps: { value: _vm.gaurenteeCampaign.upi },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.gaurenteeCampaign,
                        "upi",
                        $event.target.value
                      )
                    }
                  }
                }),
                _c(
                  "button",
                  {
                    staticStyle: {
                      "font-weight": "600",
                      color: "white",
                      width: "100%",
                      height: "2.5rem",
                      "border-radius": "4px",
                      "background-image":
                        "linear-gradient(0deg, #f4693a, #f4693a)",
                      "margin-bottom": "1rem"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveGaurenteeCampaign()
                      }
                    }
                  },
                  [_vm._v(" Confirm ")]
                )
              ])
            : _vm._e(),
          _vm.page == "gaurenteeCampaign" &&
          _vm.gaurenteeCampaign.page == "succ"
            ? _c("div", { staticClass: "ge-card" }, [
                _c("img", {
                  staticStyle: {
                    width: "inherit",
                    top: "-1rem",
                    left: "-1rem",
                    position: "relative"
                  },
                  attrs: { src: require("../../assets/wiom_succ.png") }
                }),
                _c("div", [
                  _vm._v("Your special Guaranteed income "),
                  _c("br"),
                  _vm._v("scheme has been activated.")
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-weight": "600",
                      color: "#f4693a",
                      margin: "1rem 0"
                    }
                  },
                  [_vm._v(" You will get â‚¹500 for next 3 months ")]
                ),
                _c(
                  "button",
                  {
                    staticStyle: {
                      "font-weight": "600",
                      color: "white",
                      width: "100%",
                      height: "2.5rem",
                      "border-radius": "4px",
                      "background-image":
                        "linear-gradient(0deg, #f4693a, #f4693a)",
                      "margin-bottom": "1rem"
                    },
                    on: {
                      click: function($event) {
                        return _vm.close()
                      }
                    }
                  },
                  [_vm._v(" Yah! ")]
                )
              ])
            : _vm._e(),
          _c(
            "Alert",
            {
              ref: "cnfPopup_" + _vm.cnfPopup.ref,
              attrs: { popupData: _vm.cnfPopup },
              on: {
                closed: function($event) {
                  _vm.cnfPopup.show = false
                },
                ok: function($event) {
                  return _vm.deletePlan(_vm.cnfPopup.plan)
                }
              }
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass:
                    "headline px-3 py-3 text-subtitle-1 font-weight-bold",
                  attrs: { slot: "message" },
                  slot: "message"
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { margin: "0 auto", "text-align": "center" }
                    },
                    [
                      _c("p", { staticStyle: { margin: "1rem 0" } }, [
                        _vm._v("Are you sure"),
                        _c("br"),
                        _vm._v("you want to delete this plan?")
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "Alert",
            {
              ref: "paymentSucc_" + _vm.paymentSucc.ref,
              attrs: {
                popupData: _vm.paymentSucc,
                hideCancel: true,
                okText: "Ok"
              },
              on: {
                closed: function($event) {
                  _vm.paymentSucc.show = false
                },
                ok: function($event) {
                  _vm.paymentSucc.show = false
                }
              }
            },
            [
              _c(
                "v-card-title",
                { attrs: { slot: "message" }, slot: "message" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        margin: "1em auto",
                        "font-size": ".6em",
                        "text-align": "center"
                      }
                    },
                    [
                      _c("h1", { staticStyle: { color: "#48bb78" } }, [
                        _vm._v("Success")
                      ]),
                      _c("h2", { staticStyle: { "margin-bottom": "1em" } }, [
                        _vm._v("Details saved successfully")
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "Alert",
            {
              ref: "planSucc_" + _vm.planSucc.ref,
              attrs: { popupData: _vm.planSucc, okText: "Add more plans" },
              on: {
                closed: function($event) {
                  _vm.planSucc.show = false
                  _vm.close()
                },
                ok: function($event) {
                  _vm.planSucc.show = false
                }
              }
            },
            [
              _c(
                "v-card-title",
                { attrs: { slot: "message" }, slot: "message" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        margin: "1em auto",
                        "font-size": ".6em",
                        "text-align": "center"
                      }
                    },
                    [
                      _c("h2", { staticStyle: { color: "#f2614d" } }, [
                        _vm._v("Congratulations")
                      ]),
                      _c("h2", {}, [_vm._v("Plan successfully updated")])
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm.accountDetailsPage.show
            ? _c("AccountDetails", {
                ref: "AccountDetails::" + _vm.refresh,
                attrs: { popupData: _vm.accountDetailsPage },
                on: {
                  save: function(data) {
                    return _vm.saveAccountDetails(data)
                  },
                  closed: function($event) {
                    _vm.accountDetailsPage.show = false
                  },
                  dismissed: function($event) {
                    return _vm.getPaymentModes()
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }